import React, { useState, useEffect } from "react";
import { forwardRef, useImperativeHandle } from "react";
import { BillsPaymentItems } from "../BillsPaymentItems/BillsPaymentItems";
import styles from "./billsPaymentList.module.css";
import { useSelector } from "react-redux";
import { IMAGE_PATH } from "../../../Utils/variables";
export const BillsPaymentList = forwardRef(
  ({ handleDetail, getFilterData, searched, modalState }, ref) => {
    const [initialLoading, setinitialLoading] = useState(true);
    const { isLogin, vendorId } = useSelector((state) => state.auth);
    const [value, setValue] = useState([]);
    const [activeTabId, setActiveTab] = useState(1);
    const [count, setCount] = useState("");
    const [pageNumber, setPageNumber] = useState(0);

    let pageLimit = 2;
    const onClickTabItem = (tabId) => {
      setActiveTab(tabId);
    };
    const BillsPaymentLeftList = (
      pageLimit,
      Communities,
      manageBy,
      closingOnstart,
      closingOnend,
      postedOnstart,
      postedOnend,
      serchQueryu,
    ) => {
      setPageNumber(pageNumber + pageLimit);
      fetch(process.env.REACT_APP_API_URL + "/api/vendorpo/submitBill", {
        method: "POST",
        body: JSON.stringify({
          vendor_id: vendorId,
          page_no: pageNumber,
          record_per_page: pageLimit,
          communities: Communities,
          manageBy: manageBy,
          closingOnstart: closingOnstart,
          closingOnend: closingOnend,
          postedOnstart: postedOnstart,
          postedOnend: postedOnend,
          search_query: serchQueryu,
        }),
        headers: { "content-type": "application/json" },
      })
        .then((d) => d.json())
        .then((result) => {
          const normaBills = result.response.normal_bills
          const vendorBills = result.response.vendor_bills
          const allBills = [...vendorBills.data, ...normaBills.data]
          setCount(allBills?.length ? allBills?.length: 0);
          if (allBills?.length === 0) {
            handleDetail("", "");
            setActiveTab("");
            setValue([]);
          } else {
            setValue(allBills);
            const isNormalBill = allBills[0].is_normal_bill
            handleDetail(
              allBills[0].id,
              allBills[0].bill_community_id,
              isNormalBill
            );
            setActiveTab(allBills[0].id);
          }
          setinitialLoading(false);
        })
        .catch((err) => {
          setinitialLoading(false);
          console.log("e", err);
        });
    };
    useEffect(() => {
      setinitialLoading(true)
      setValue([])
      BillsPaymentLeftList(
        pageLimit,
        getFilterData.Communities,
        getFilterData.manageBy,
        getFilterData.closingOnstart,
        getFilterData.closingOnend,
        getFilterData.postedOnstart,
        getFilterData.postedOnend,
        searched
      );
    }, [getFilterData, modalState]);
    useEffect(() => {
      setinitialLoading(true)
      setValue([])
      BillsPaymentLeftList(
        pageLimit,
        getFilterData.Communities,
        getFilterData.manageBy,
        getFilterData.closingOnstart,
        getFilterData.closingOnend,
        getFilterData.postedOnstart,
        getFilterData.postedOnend,
        searched
      );
    }, [searched]);

    const reFetchBills = () => {
      BillsPaymentLeftList(
        pageLimit,
        getFilterData.Communities,
        getFilterData.manageBy,
        getFilterData.closingOnstart,
        getFilterData.closingOnend,
        getFilterData.postedOnstart,
        getFilterData.postedOnend,
        searched
      );
    };

    const fetchMore = () => {
      if (value.length < count) {
        BillsPaymentLeftList(
          pageLimit,
          getFilterData.Communities,
          getFilterData.manageBy,
          getFilterData.closingOnstart,
          getFilterData.closingOnend,
          getFilterData.postedOnstart,
          getFilterData.postedOnend,
          searched
        );
      }
    };

    useImperativeHandle(ref, () => ({
      triggerMyFunction: reFetchBills,
    }));
    return (
      <>
        <div>
          <div className={styles.topPOList}>
            <div className={styles.topNavPO}>
              <h1>Bills List</h1>
            </div>
            {value && value.length > 0 ? (
              <div className={styles.middlePOList} id="scrollableDiv">
                {value.map((item) => {
                  return (
                    <BillsPaymentItems
                      key={item.id}
                      handleDetail={handleDetail}
                      onClickTabItem={onClickTabItem}
                      {...item}
                      activeTabId={activeTabId}
                    />
                  );
                })}
                {/* </InfiniteScroll> */}
              </div>
            ) : (
              <div className={styles.middlePOList}>
                <div className="noDataToShowList">
                  {initialLoading ? (
                    <i
                      className="fa fa-spinner fa-spin "
                      style={{
                        color: "var(--BaseDarkColor)",
                        fontSize: "40px",
                      }}
                    ></i>
                  ) : (
                    <img src={IMAGE_PATH + "billsList.svg"} alt="" />
                  )}
                </div>
              </div>
            )}
          </div>
        </div>
      </>
    );
  }
);
